import { ConfigProvider, Layout, message as antMessage } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { createContext, useContext, useEffect, useState } from 'react';
import Route from 'AppRoute';
import Header from 'layout/Header';
import './App.css';
import './AppDesk.css';
import './AppMobile.css';
import { useAuth } from 'AuthContext';
import Footer from 'layout/Footer';
import viVN from 'antd/locale/vi_VN';
import FullMask from 'layout/FullMask';

const GeneralContext = createContext();

export default function App() {
    const [header, setHeader] = useState(false);
    const [fullMask, setFullMask] = useState(false);
    const { getUserInfo } = useAuth();
    const [message, contextHolder] = antMessage.useMessage();
    useEffect(()=>{
        getUserInfo();
    },[getUserInfo])
    return (
        <ConfigProvider locale={viVN} theme={{ token: { colorPrimary: '#770707' }, cssVar: true }}>
            <GeneralContext.Provider value={{ setFullMask, message }}>
                <Layout className="layout" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                    { contextHolder }
                    {header && <Header />}
                    <Content >
                        <div className="main-div site-layout-content container p-3 mt-3 mb-3">
                            <Route setHeader={setHeader}/>
                        </div>
                    </Content>
                    {header && <Footer/>}
                    </Layout>
            </GeneralContext.Provider>
            {fullMask && <FullMask />}
        </ConfigProvider>
    );
}

const useGeneral = () => useContext(GeneralContext);

export { useGeneral }